export class TypedEventEmitter<EventMap extends Record<string, unknown>> {
  private listeners: {
    [K in keyof EventMap]?: Set<(payload: EventMap[K]) => void>;
  } = {} as never;

  on<K extends keyof EventMap>(
    event: K,
    listener: (payload: EventMap[K]) => void
  ): void {
    const set = (this.listeners[event] ||= new Set());
    set.add(listener as (payload: unknown) => void as never);
  }

  off<K extends keyof EventMap>(
    event: K,
    listener: (payload: EventMap[K]) => void
  ): void {
    this.listeners[event]?.delete(
      listener as (payload: unknown) => void as never
    );
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    const set = this.listeners[event];
    if (!set || set.size === 0) return;
    for (const fn of set) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (fn as any)(payload);
      } catch (_err) {
        // ignore listener errors to avoid breaking other listeners
      }
    }
  }

  clearAll(): void {
    for (const key of Object.keys(this.listeners)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.listeners as any)[key]?.clear?.();
    }
  }
}
